import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import BaseTabs from "../../common/base-tabs/base-tabs";

//import view components
import FlightInformation from "./flight-information";
import HotelInformation from "./hotel-information";
import PassengersInformation from "./passengers-information";
import FlightInformationMobile from "./mobile/flight-information";
import HotelInformationMobile from "./mobile/hotel-information";
import PassengersInformationMobile from "./mobile/passenger-information";
import { flightDataMapper } from "../../../utils/flightDataMapper";
import BusInformation from "./bus-information";

function DomesticInformation({ newFlightPrice }) {
    //general variables
    const { t } = useTranslation();

    //sessionStorage variables
    const domesticFlightInformation = JSON.parse(sessionStorage.getItem("domesticFlightInformation"));
    const selectedFlight = JSON.parse(sessionStorage.getItem("selectedFlight"));
    const flightPassengers = JSON.parse(sessionStorage.getItem("flightPassengers"));

    const selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel"));
    const selectedRooms = JSON.parse(sessionStorage.getItem("selectedRooms"));
    const selectedIntRooms = JSON.parse(sessionStorage.getItem("selectedIntRooms"));
    const hotelPassengers = JSON.parse(sessionStorage.getItem("hotelPassengers")) || JSON.parse(sessionStorage.getItem("intHotelPassengers"));

    const selectedBus = JSON.parse(sessionStorage.getItem("selectedBus"));
    const busPassengers = JSON.parse(sessionStorage.getItem("busPassengers"));

    //general variables
    const isTwoWay = domesticFlightInformation?.returnDate;
    const normalizedDepartureFlight = flightDataMapper(isTwoWay, selectedFlight, selectedFlight?.segments);
    const normalizedReturnFlight = flightDataMapper(isTwoWay, selectedFlight, selectedFlight?.return_segments);

    //handle tab change
    const [activeTab, setActiveTab] = useState({
        departure: true,
        return: false,
        hotel: !selectedFlight?.segments?.length && !!selectedHotel ? true : false,
    });
    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    //list of tabs
    const tabList = [
        {
            type: "departure",
            title: t("departureFlight"),
            activeTab: activeTab?.departure,
            disable: !selectedFlight,
        },
        { type: "return", title: t("returnFlight"), activeTab: activeTab?.return, disable: !selectedFlight?.return_segments?.length },
        { type: "hotel", title: t("hotel"), activeTab: activeTab?.hotel, disable: !selectedRooms && !selectedIntRooms },
    ];

    //Flatten the array of passengers
    const [flatPassengersList, setFlatPassengersList] = useState([]);
    useEffect(() => {
        const passengers = hotelPassengers?.rooms?.flatMap(room => room.passengers) || hotelPassengers?.passengers;
        setFlatPassengersList({ passengers });
    }, []);

    return (
        <>
            {IS_MOBILE ? (
                <Grid container item xs={12} justifyContent="space-between" rowGap={3}>
                    <BaseTabs handleTabChange={handleTabChange} list={tabList} style={{ top: "3rem" }} />
                    {selectedFlight && (activeTab?.departure || activeTab?.return) && (
                        <>
                            <FlightInformationMobile
                                selectedFlight={activeTab?.departure ? normalizedDepartureFlight : normalizedReturnFlight}
                                newPrice={newFlightPrice}
                                isTwoWay={isTwoWay}
                            />
                            <PassengersInformationMobile title={t("passengers")} information={flightPassengers} />
                        </>
                    )}

                    {activeTab.hotel && (
                        <>
                            <HotelInformationMobile selectedHotel={selectedHotel} />
                            <PassengersInformationMobile title={t("supervisor")} information={flatPassengersList} />
                        </>
                    )}
                </Grid>
            ) : (
                <Grid container item xs={12} justifyContent="space-between" rowGap={5}>
                    {!!selectedBus && <BusInformation selectedBus={selectedBus} />}
                    {!!selectedFlight && (
                        <FlightInformation
                            title={t("departureTicket")}
                            selectedFlight={normalizedDepartureFlight}
                            iconName="departure-icon"
                            newPrice={newFlightPrice}
                            isTwoWay={isTwoWay}
                        />
                    )}
                    {!!selectedFlight && !!isTwoWay && (
                        <FlightInformation
                            title={t("returnTicket")}
                            selectedFlight={normalizedReturnFlight}
                            iconName="return-icon"
                            newPrice={newFlightPrice}
                            isTwoWay={isTwoWay}
                        />
                    )}
                    {!!flightPassengers && <PassengersInformation title={t("flightPassenger")} information={flightPassengers} type="flight" />}
                    {(!!selectedRooms || !!selectedIntRooms) && <HotelInformation title={t("hotel")} />}{" "}
                    {/*for dometic hotel of grs and dometic hotel of parto */}
                    {!!hotelPassengers && !!selectedRooms && (
                        <PassengersInformation title={t("hotelPassenger")} information={flatPassengersList} type="hotel" />
                    )}{" "}
                    {/*for dometic hotel of grs */}
                    {!!hotelPassengers && !!selectedIntRooms && (
                        <PassengersInformation title={t("hotelPassenger")} information={flatPassengersList} type="intHotel" />
                    )}{" "}
                    {!!busPassengers && <PassengersInformation title={t("passengers")} information={busPassengers} type="bus" />}{" "}
                </Grid>
            )}
        </>
    );
}

export default DomesticInformation;
